import { useState, useEffect, useCallback } from "react";
import { GOLD, TEMAS } from "../constants/temas";

export default function SplashScreen({ onFim }) {
    const temaSalvo = (() => {
        try { return JSON.parse(localStorage.getItem("tema")) || "escuro"; } catch { return "escuro"; }
    })();
    const T = TEMAS[temaSalvo];
    const escuro = temaSalvo === "escuro";

    const [visivel, setVisivel] = useState(false);
    const [saindo, setSaindo] = useState(false);
    const fim = useCallback(onFim, [onFim]);

    useEffect(() => {
        const t1 = setTimeout(() => setVisivel(true), 80);
        const t2 = setTimeout(() => setSaindo(true), 1400);
        const t3 = setTimeout(() => fim(), 1800);
        return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
    }, [fim]);

    return (
        <div style={{
            position: "fixed", inset: 0,
            background: T.bg,
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            zIndex: 9999,
            opacity: saindo ? 0 : 1,
            transition: "opacity 0.4s ease",
        }}>
            <style>{`
                @keyframes logoIn {
                    0%   { opacity: 0; transform: scale(0.75); }
                    70%  { opacity: 1; transform: scale(1.05); }
                    100% { opacity: 1; transform: scale(1); }
                }
                @keyframes glowPulse {
                    0%, 100% { filter: drop-shadow(0 0 14px #F9A826bb) drop-shadow(0 0 35px #F9A82655); }
                    50%      { filter: drop-shadow(0 0 24px #F9A826ff) drop-shadow(0 0 60px #F9A82688); }
                }
                @keyframes fadeUp {
                    0%   { opacity: 0; transform: translateY(12px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
            `}</style>

            {/* Glow de fundo sutil */}
            <div style={{
                position: "absolute",
                width: 280, height: 280,
                borderRadius: "50%",
                background: `radial-gradient(circle, ${GOLD}15 0%, transparent 70%)`,
                opacity: visivel ? 1 : 0,
                transition: "opacity 0.8s ease",
                pointerEvents: "none",
            }} />

            {/* Logo */}
            <div style={{
                marginBottom: 20,
                position: "relative", zIndex: 1,
                animation: visivel ? "logoIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards, glowPulse 2s ease-in-out 0.6s infinite" : "none",
                opacity: 0,
            }}>
                <img
                    src="/logo.png"
                    alt="AdoraTeam"
                    style={{
                        width: 100,
                        height: "auto",
                        display: "block",
                        mixBlendMode: escuro ? "screen" : "multiply",
                    }}
                />
            </div>

            {/* Nome */}
            <div style={{
                animation: visivel ? "fadeUp 0.5s ease 0.4s forwards" : "none",
                opacity: 0,
                display: "flex", alignItems: "baseline", gap: 1,
                position: "relative", zIndex: 1,
            }}>
                <span style={{ fontSize: 34, fontWeight: 900, color: T.texto, letterSpacing: -1 }}>Adora</span>
                <span style={{ fontSize: 34, fontWeight: 900, color: GOLD, letterSpacing: -1 }}>Team</span>
            </div>

            {/* Tagline */}
            <div style={{
                animation: visivel ? "fadeUp 0.5s ease 0.6s forwards" : "none",
                opacity: 0,
                marginTop: 8,
                fontSize: 13,
                color: T.textoSecundario,
                letterSpacing: 0.3,
                position: "relative", zIndex: 1,
            }}>
                Sua equipe de louvor em um só lugar
            </div>
        </div>
    );
}